// @format
import React, { Component } from 'react';
import styled from 'styled-components';

const MainCanvas = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #224052;
  background-image: radial-gradient(#224052, #172b38);
  display: flex;
  /* align-items: center; */
  justify-content: center;
  font-family: 'Open Sans', sans-serif;
`;

const TagWrapper = styled.div`
  position: relative;
  top: 33vh;
  height: 7.594rem;
`;

const Tag = styled.div`
  font-size: 7.594rem;
  color: rgb(240, 240, 255);
  font-family: 'Notable', sans-serif;
  text-shadow: 0 1rem 2.25rem rgba(2, 18, 37, 0.43);
  line-height: 7.594rem;
  padding-left: 5.063rem;
  padding-right: 5.063rem;
`;


const SmallTag = Tag.extend`
  color: rgb(235, 235, 255);
  display: inline-block;
  font-size: 3.375rem;
  border: none;
  padding: 0;
`;

const Line = styled.hr`
  margin: 0.198rem;
  border-color: #8897a7;
  box-shadow: 0 .667rem .667rem rgba(2, 18, 37, 0.43);
`;

class App extends Component {
  render() {
    return (
      <MainCanvas>
        <TagWrapper>
          <Line />
          <Line />
          <Tag>
            48
            <SmallTag>S</SmallTag>
          </Tag>
          <Line />
          <Line />
        </TagWrapper>
      </MainCanvas>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js